import { init } from "@instantdb/react";
import schema from "../instant.schema";

const APP_ID = import.meta.env.VITE_INSTANT_APP_ID;

if (!APP_ID) {
	throw new Error(
		"Missing VITE_INSTANT_APP_ID. Copy .env.example to .env.local and set your InstantDB app id.",
	);
}

export const db = init({ appId: APP_ID, schema, devtool: false });
